import { render, staticRenderFns } from "./tagSwiper.vue?vue&type=template&id=2e924d62&scoped=true&"
import script from "./tagSwiper.vue?vue&type=script&lang=js&"
export * from "./tagSwiper.vue?vue&type=script&lang=js&"
import style0 from "./tagSwiper.vue?vue&type=style&index=0&id=2e924d62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e924d62",
  null
  
)

export default component.exports